<tr [formGroup]="efficiencyForm">
    <td class="efficiency-name">
        <br>
        {{ ('SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.'+step+"_FORM."+labelMap.title+'.TITLE') | translate }}
        <br>
    </td>
    <td class="efficiency-rating">
        <mat-form-field appearance="outline">
            <mat-label>
                {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.CURRENT_STATE' | translate }}
            </mat-label>
            <mat-select formControlName="currentState">
                <mat-option class="mat-option-text"></mat-option>
                <mat-option class="mat-option-text" *ngFor="let r of ratings" [value]="r">
                    {{ r }} - {{ ('SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.' + step + '_FORM.' + labelMap.title + '.' + r) | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </td>
    <td class="efficiency-outcome">
        <mat-form-field appearance="outline">
            <mat-label>
                {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.EXPECTED_OUTCOME' | translate }}
            </mat-label>
            <mat-select formControlName="expectedOutcome">
                <mat-option class="mat-option-text"></mat-option>
                <mat-option class="mat-option-text" *ngFor="let r of ratings" [value]="r">
                    {{ r }} - {{ ('SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.' + step + '_FORM.' + labelMap.title + '.' + r) | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </td>
</tr>
